"use client";
import { UEListData } from "@/app/interface/homepage";
import UEHeroCard from "@/app/unlisted-shares/components/ue-hero-card";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { formatIndianCurrency } from "@/app/utils/helper";

// New interface for user rewards data
interface UserReward {
    date: string;
    productType: string;
    product: string;
    productName: string;
    cashback: number;
    purchaseDiscount: number;
    units: number;
}

interface UserRewardsResponse {
    data: UserReward[];
}

interface RewardPostInvestmentSectionProps {
    isUELoading?: boolean;
    data: UEListData[];
    userRewardsData: UserRewardsResponse;
    isUserRewardsLoading: boolean;
    referrerEmail?: string;
    userId?: string;
    phone?:string;
    isLoading?: boolean;
}

const RewardPostInvestmentSection: React.FC<RewardPostInvestmentSectionProps> = ({
    isUELoading,
    data,
    userRewardsData,
    isUserRewardsLoading,
    referrerEmail,
    userId,
    phone,
    isLoading,
}) => {
    const [showAll, setShowAll] = useState(false);

    const exploreUeOpportunities = () => {
        window.location.href = `${process.env.ICM_UE_POST_URL_LISTING}` || "/";
    };

    const visibleRows = showAll ? userRewardsData?.data : userRewardsData?.data?.slice(0, 4);

    // if (isUserRewardsLoading) {
    //     <div className="w-[1152px] min-h-[423px] mx-auto flex justify-center items-center">
    //         <LoadingIcon className="m-auto animate-spin w-10 h-10 sm:w-12 sm:h-12" />
    //     </div>
    // }

    if (isLoading) {
        return (
            <div className="mx-auto flex w-full flex-col items-center justify-center md:w-[1152px] gap-8 md:gap-[54px] px-6 md:px-0">
                {/* Skeleton for Rewards earned table */}
                <div className="mt-8 md:mt-[54px] flex w-full flex-col justify-start">
                    <div className="mb-s7 md:mb-s9 h-8 w-48 rounded bg-gray-200 animate-pulse" />
                    <div className="w-full overflow-hidden rounded-lg border bg-white">
                        <div className="overflow-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="h-[70px]">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <th key={i} className="w-1/5 py-3">
                                                <div className="h-4 w-24 rounded bg-gray-200 animate-pulse mx-auto" />
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: 4 }).map((_, rowIdx) => (
                                        <tr className="h-[70px]" key={rowIdx}>
                                            {Array.from({ length: 5 }).map((_, colIdx) => (
                                                <td key={colIdx} className="w-1/5 py-3">
                                                    <div className="h-4 w-20 rounded bg-gray-100 animate-pulse mx-auto" />
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="mt-4 flex w-full justify-center">
                        <div className="h-10 w-32 rounded bg-gray-200 animate-pulse" />
                    </div>
                </div>
                {/* Skeleton for Most popular section */}
                <div className="mx-6 flex flex-col items-center justify-center gap-0 md:gap-5 text-center md:mx-0 my-0 md:my-14 md:mb-0 md:mt-6">
                    <div className="mx-auto mb-3 h-8 w-40 rounded bg-gray-200 animate-pulse" />
                    <div className="mx-auto h-6 w-64 rounded bg-gray-100 animate-pulse" />
                </div>
                {/* Skeleton for UEHeroCard grid */}
                <div className="grid grid-cols-1 gap-[8px] md:grid-cols-2 md:gap-4">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div
                            key={index}
                            className="w-[300px] animate-pulse rounded-2xl border-2 border-gray-200 p-4 md:w-[442px] md:p-6"
                        >
                            <div className="flex gap-4 bg-gray-200">
                                <div className="h-12 w-12 flex-shrink-0 bg-gray-300 md:h-20 md:w-20"></div>
                                <div className="flex min-w-0 flex-1 items-center justify-between">
                                    <div className="flex min-w-0 max-w-[calc(100%-40px)] flex-col gap-2">
                                        <div className="overflow-hidden">
                                            <div className="h-4 w-24 rounded bg-gray-300"></div>
                                        </div>
                                        <div className="h-4 w-16 rounded bg-gray-300"></div>
                                    </div>
                                    <div className="h-8 w-8 flex-shrink-0 rounded-full bg-gray-300"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Skeleton for Explore Unlisted Shares button */}
                <div className="mt-5 w-full max-w-full md:mt-0 md:w-auto">
                    <div className="h-12 w-60 rounded bg-gray-200 animate-pulse mx-auto" />
                </div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="mx-auto flex w-full flex-col items-center justify-center md:w-[1152px] gap-8 md:gap-[54px] px-6 md:px-0">
                {/* Skeleton for Rewards earned table */}
                <div className="mt-8 md:mt-[54px] flex w-full flex-col justify-start">
                    <div className="mb-s7 md:mb-s9 h-8 w-48 rounded bg-gray-200 animate-pulse" />
                    <div className="w-full overflow-hidden rounded-lg border bg-white">
                        <div className="overflow-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="h-[70px]">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <th key={i} className="w-1/5 py-3">
                                                <div className="h-4 w-24 rounded bg-gray-200 animate-pulse mx-auto" />
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: 4 }).map((_, rowIdx) => (
                                        <tr className="h-[70px]" key={rowIdx}>
                                            {Array.from({ length: 5 }).map((_, colIdx) => (
                                                <td key={colIdx} className="w-1/5 py-3">
                                                    <div className="h-4 w-20 rounded bg-gray-100 animate-pulse mx-auto" />
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="mt-4 flex w-full justify-center">
                        <div className="h-10 w-32 rounded bg-gray-200 animate-pulse" />
                    </div>
                </div>
                {/* Skeleton for Most popular section */}
                <div className="mx-6 flex flex-col items-center justify-center gap-0 md:gap-5 text-center md:mx-0 my-0 md:my-14 md:mb-0 md:mt-6">
                    <div className="mx-auto mb-3 h-8 w-40 rounded bg-gray-200 animate-pulse" />
                    <div className="mx-auto h-6 w-64 rounded bg-gray-100 animate-pulse" />
                </div>
                {/* Skeleton for UEHeroCard grid */}
                <div className="grid grid-cols-1 gap-[8px] md:grid-cols-2 md:gap-4">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div
                            key={index}
                            className="w-[300px] animate-pulse rounded-2xl border-2 border-gray-200 p-4 md:w-[442px] md:p-6"
                        >
                            <div className="flex gap-4 bg-gray-200">
                                <div className="h-12 w-12 flex-shrink-0 bg-gray-300 md:h-20 md:w-20"></div>
                                <div className="flex min-w-0 flex-1 items-center justify-between">
                                    <div className="flex min-w-0 max-w-[calc(100%-40px)] flex-col gap-2">
                                        <div className="overflow-hidden">
                                            <div className="h-4 w-24 rounded bg-gray-300"></div>
                                        </div>
                                        <div className="h-4 w-16 rounded bg-gray-300"></div>
                                    </div>
                                    <div className="h-8 w-8 flex-shrink-0 rounded-full bg-gray-300"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Skeleton for Explore Unlisted Shares button */}
                <div className="mt-5 w-full max-w-full md:mt-0 md:w-auto">
                    <div className="h-12 w-60 rounded bg-gray-200 animate-pulse mx-auto" />
                </div>
            </div>
        );
    }

    return (
        <div className="mx-auto flex w-full flex-col items-center justify-center md:w-[1152px] gap-8 md:gap-[54px] px-6 md:px-0">
            {/* {isUserRewardsLoading && (
                <div className="mx-auto flex min-h-[200px] w-full md:w-[1152px] items-center justify-center">
                    <LoadingIcon className="m-auto h-10 w-10 animate-spin sm:h-12 sm:w-12" />
                </div>
            )} */}
            {!isUserRewardsLoading && userRewardsData?.data && (
                <div className="mt-8 md:mt-[54px] flex w-full flex-col justify-start">
                    <p className="mb-s7 md:mb-s9 text-center md:text-left text-4xl md:text-3xl font-semibold leading-[31.2px] tracking-[-0.24px]">
                        Rewards earned
                    </p>
                    <div className="w-full overflow-hidden rounded-lg border bg-white">
                        <div
                            className={`transition-all duration-300 ease-in-out overflow-auto ${
                                showAll ? "max-h-max" : ""
                            }`}
                        >
                            <Table className="w-full">
                                <TableHeader>
                                    <TableRow className="h-[70px]">
                                        <TableHead className="w-1/5 py-3 text-sm md:text-md font-semibold leading-[25.6px] text-neutral-900">
                                            Transaction Date
                                        </TableHead>
                                        <TableHead className="w-1/5 py-3 text-sm md:text-md font-semibold leading-[25.6px] text-neutral-900">
                                            Product Name
                                        </TableHead>
                                        <TableHead className="w-1/5 py-3 text-sm md:text-md font-semibold leading-[25.6px] text-neutral-900">
                                            Product Type
                                        </TableHead>
                                        <TableHead className="w-1/5 py-3 text-sm md:text-md font-semibold leading-[25.6px] text-neutral-900">
                                            Cashback
                                        </TableHead>
                                        <TableHead className="w-1/5 py-3 text-sm md:text-md font-semibold leading-[25.6px] text-neutral-900">
                                            Purchase Discount
                                        </TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {visibleRows?.map((row, index: number) => (
                                        <TableRow className="h-[70px]" key={index}>
                                            <TableCell className="w-1/5 py-3 text-xs md:text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-900">
                                                {row?.date ? row?.date?.split(" ")[0] : "--"}
                                            </TableCell>
                                            <TableCell className="w-1/5 py-3 text-xs md:text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-900">
                                                {row.productName}
                                            </TableCell>
                                            <TableCell className="w-1/5 py-3 text-xs md:text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-900">
                                                {row.productType}
                                            </TableCell>
                                            <TableCell className="w-1/5 py-3 text-xs md:text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-900">
                                                {formatIndianCurrency(row.cashback)}
                                            </TableCell>
                                            <TableCell className="w-1/5 py-3 text-xs md:text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-900">
                                                {formatIndianCurrency(row.purchaseDiscount)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                    {userRewardsData && userRewardsData?.data?.length > 4 && (
                        <div className="mt-4 flex w-full justify-center">
                            <RegularButton
                                noIcon
                                showRightIcon={false}
                                size={ButtonSize.Medium}
                                variant={ButtonVariant.SecondaryDefault}
                                className="w-full max-w-full md:mt-0 md:w-auto"
                                label={showAll ? "Show Less" : "Show More"}
                                onClick={() => setShowAll(!showAll)}
                            />
                        </div>
                    )}
                </div>
            )}
            <div className="mx-6 flex flex-col items-center justify-center gap-0 md:gap-5 text-center md:mx-0 my-0 md:my-14 md:mb-0 md:mt-6">
                <div
                    className="mx-auto mb-3 max-w-[828px] text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-neutral-900 md:mb-0 md:text-7xl md:leading-[67px] md:tracking-[-0.56px]"
                    dangerouslySetInnerHTML={{ __html: "Most popular" }}
                />
                {userRewardsData?.data?.length ? null : <div
                    className="mx-auto text-md leading-[25.6px] tracking-[-0.2px] text-neutral-500 md:max-w-[872px] md:text-xl md:leading-[32px]"
                    dangerouslySetInnerHTML={{ __html: "Claim your 0.25% discount right away." }}
                />}
            </div>
            <div className="grid grid-cols-1 gap-[8px] md:grid-cols-2 md:gap-4">
                {isUELoading
                    ? Array.from({ length: 4 }).map((_, index) => (
                          <div
                              key={index}
                              className="w-[300px] animate-pulse rounded-2xl border-2 border-gray-200 p-4 md:w-[442px] md:p-6"
                          >
                              <div className="flex gap-4 bg-gray-200">
                                  {/* Image container with fixed dimensions */}
                                  <div className="h-12 w-12 flex-shrink-0 bg-gray-300 md:h-20 md:w-20"></div>

                                  {/* Content wrapper with proper flex behavior */}
                                  <div className="flex min-w-0 flex-1 items-center justify-between">
                                      {/* Text content with proper truncation */}
                                      <div className="flex min-w-0 max-w-[calc(100%-40px)] flex-col gap-2">
                                          <div className="overflow-hidden">
                                              <h3 className="h-4 w-24 truncate bg-gray-300 text-sm font-semibold md:text-lg"></h3>
                                          </div>
                                          <div className="whitespace-nowrap text-sm">
                                              <span className="h-4 w-16 bg-gray-300 text-gray-400"></span>
                                          </div>
                                      </div>

                                      {/* Button placeholder */}
                                      <div className="h-8 w-8 flex-shrink-0 rounded-full bg-gray-300"></div>
                                  </div>
                              </div>
                          </div>
                      ))
                    : data?.map((card: UEListData, index: number) => (
                          <UEHeroCard key={index} {...card} refEvent={`US_Rewards_${card.product}`} email={referrerEmail} userId={userId} phone={phone}/>
                      ))}
            </div>

            <RegularButton
                noIcon
                showRightIcon={false}
                size={ButtonSize.Large}
                variant={ButtonVariant.PrimaryDefault}
                className="mt-5 w-full max-w-full md:mt-0 md:w-auto"
                label="Explore Unlisted Shares"
                onClick={() => exploreUeOpportunities()}
            />
        </div>
    );
};

export default RewardPostInvestmentSection;